import { FileProcessingStatus } from '../domain/enums';
import { JsonObject } from '../domain/types';
import {
  COMPLETED_STATUSES,
  FAILED_STATUSES,
  IN_FLIGHT_STATUSES,
  IngestionStats,
} from '../types';

/**
 * The summary's `byStatus` is an opaque `FileProcessingStatus` → count map
 * forwarded verbatim by PDGS. Counts are small enough to be plain numbers,
 * so a missing or non-numeric entry is treated as zero.
 */
const sumCountsForStatuses = (
  byStatus: JsonObject,
  statuses: FileProcessingStatus[],
): number =>
  statuses.reduce((total, status) => {
    const count = Number(byStatus[status]);

    return total + (Number.isFinite(count) ? count : 0);
  }, 0);

export const computeIngestionStats = (
  byStatus: JsonObject,
  totalRowsParsed: string,
): IngestionStats => ({
  inFlightCount: sumCountsForStatuses(byStatus, IN_FLIGHT_STATUSES),
  failedCount: sumCountsForStatuses(byStatus, FAILED_STATUSES),
  completedCount: sumCountsForStatuses(byStatus, COMPLETED_STATUSES),
  totalRowsParsed,
});

export const EMPTY_INGESTION_STATS: IngestionStats = {
  inFlightCount: 0,
  failedCount: 0,
  completedCount: 0,
  totalRowsParsed: '0',
};
